import React from "react";
import { Modal, Button, ConfigProvider } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { CheckCircleFilled } from "@ant-design/icons";
import { clearStorage } from "../utils";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import {
  textTitleHome,
  checkCircleIcon,
  colorTextTitleMobile,
  colorTextDesc,
} from "../config/constant/color/index";
import { useTranslation } from "react-i18next";

const ModalSuccessCheck = ({
  setModalSuccess,
  modalSuccess,
  textTitle,
  textDesc,
  mainState,
  confirmRating,
}) => {
  const screens = useBreakpoint();
  const isScallingVersion =
  window.innerWidth < 992 && (window.innerHeight >= window.innerWidth || window.innerWidth > window.innerHeight);
  const isMobileVersion = screens.xs || isScallingVersion;
    const { t, i18n } = useTranslation();

  var navigate = useNavigate();
  const location = useLocation();
  const locPathname = location.pathname;
  const arrId = locPathname.split("/");

  const onClickOK = () => {
    setModalSuccess(!modalSuccess);
    if (confirmRating === true) {
      navigate(mainState.popupStream.url);
    } else {
      clearStorage();
      navigate(`${import.meta.env.BASE_URL}login`);
    }
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Modal: {
            borderRadiusLG: isMobileVersion ? "16px" : "24px",
          },
        },
        token: {
          fontFamily: "Roboto",
        },
      }}
    >
      <Modal
        open={modalSuccess}
        maskClosable="false"
        closeIcon={false}
        width={420}
        style={{ maxWidth: isMobileVersion ? "90%" : "420px" }}
        centered
        footer={null}
      >
        <div
          style={{
            textAlign: "center",
            padding: isMobileVersion ? "20px" : "32px",
          }}
        >
          <CheckCircleFilled
            style={{
              color: checkCircleIcon,
              fontSize: "60px",
              marginBottom: "20px",
            }}
          />
          <div
            style={{
              fontSize: isMobileVersion ? "16px" : "22px",
              color: isMobileVersion ? colorTextTitleMobile : textTitleHome,
              lineHeight: isMobileVersion ? "100%" : "normal",
              fontWeight: "500",
            }}
          >
            {textTitle}
          </div>
          <p
            style={{
              color: isMobileVersion ? colorTextDesc : textTitleHome,
              fontSize: isMobileVersion ? "14px" : "inherit",
              fontWeight: "400",
              margin: "8px auto",
              maxWidth: "95%",
            }}
          >
            {textDesc}
          </p>

          <Button
            className="btn btn-sm btn-primary btn-block"
            style={{
              borderRadius: "6px",
              border: "none",
              fontWeight: "500",
              marginTop: isMobileVersion ? "20px" : "30px",
              height: isMobileVersion ? "40px" : "48px",
            }}
            name="btn-ok-change-password"
            onClick={() => onClickOK()}
          >
            {
              arrId.indexOf("change-password") > -1 ?
                "Log In Now"
                :
                confirmRating === false ?
                  t("feature.home.pop_up_change_password.log_in_now")
                  :
                  "OK"
            }
          </Button>
        </div>
      </Modal>
    </ConfigProvider>
  );
};

export default ModalSuccessCheck;
